export const getDiscountedPrice = (discountRate = 0, startUpFeePerSchool) =>
  Math.round((1 - discountRate * 0.01) * startUpFeePerSchool);

export const roundDecimal = (value, decimals) =>
  Math.round(value) === Number(value)
    ? value
    : Number(`${Math.round(`${value}e${decimals}`)}e-${decimals}`);



// WEBPACK FOOTER //
// ./src/_shared/utils/utils.js